// Wrapper component that shows desktop or mobile version based on screen size
import HomePageDesktop from './HomePageDesktop';
import HomePageMobile from './HomePage';

export default function HomePageWrapper() {
  return (
    <>
      {/* Desktop version - hidden on mobile/tablet */}
      <div className="hidden lg:block">
        <HomePageDesktop />
      </div>
      
      {/* Mobile version - hidden on desktop */}
      <div className="lg:hidden">
        <HomePageMobile />
      </div>
    </>
  );
}
